import { useMutateScheduleSupplyCell, useMutateProcessorMatchCandidateCell } from './queries';
import MutateSupplyCellSchema from '../../../main/apps/FunctionalApps/schedule-list-view/supply/MutateSupplyItem/MutateSupplyCell.schema';
import MutateProcessorMatchCandidateSchema from './schemas';

// configuration setup for handling mutations using a TanStack useMutation query
// each configuration defines:
// 1. handleMutate: an function to handle the mutation logic
//    - it should accept two parameters:
//      - an object containing arguments: id (resource identifier) and body (payload)
//      - a function provided by the useMutation hook used to trigger a mutation, such as mutateAsync
//    - it must return the result of the call
// 2. useHook: a function that initializes and returns the specific hook used for this configuration
//    - this must be a function returning a hook invocation, ensuring hooks are called within React's lifecycle
// 3. schema: a Yup validation schema to validate and sanitize data before passing it to the mutation
//    - the schema should include fields relevant to this configuration's context and can include `meta` data
//      for additional processing (see example `extractIdFields` in MutateSupplyCellSchema)

const schedule = {
    handleMutate: ({ id, body }, { mutate }) => {
        return mutate({ method: 'PATCH', endpoint: `/schedule-supply-item/${id}`, id, body });
    },
    useHook: () => useMutateScheduleSupplyCell(),
    schema: MutateSupplyCellSchema,
};

const processorMatchCandidate = {
    handleMutate: ({ id, body }, { mutate }) => {
        const type = 'scheduleAutopilotProcessorMatch';
        return mutate({ method: 'PATCH', endpoint: `/match-candidates/${type}/${id}`, id, body });
    },
    useHook: () => useMutateProcessorMatchCandidateCell(),
    schema: MutateProcessorMatchCandidateSchema,
};

export default { schedule, processorMatchCandidate };
